import { useContext } from 'react'
import { ClientContext } from '@contexts/index'

export const useClientContext = () => useContext(ClientContext)
